import { render, staticRenderFns } from "./layoutItem.vue?vue&type=template&id=57c59b90&"
import script from "./layoutItem.vue?vue&type=script&lang=js&"
export * from "./layoutItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports